module.exports = __webpack_public_path__ + "static/media/abbey-modal.bb29351d.jpg";